module.exports = __webpack_public_path__ + "static/media/color3.3f86e97c.svg";